import NewsModal from "./NewsModal";
import "./Newsroom.css";
import React, { useRef, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";



const Newsroom = () => {
  
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };
  return (
    <div>
      <div className="hero_img newsroom_div31">
      <img src="/assets/inthenews.jpg" alt="" />

      <div className="hero_title">In the news</div>

      </div>
      <div className="container2">
        <div className="newsp_div1">
          <div className="newsp_flex">
            <div className="newsp_div11">
              <img src="/assets/newsroom/newsPageimg2.jpg" alt="" />
              <span>
                Brookfield buys ​Space Teleinfra for over Rs 900 crore in
                cash-cum-units deal
              </span>
              <a target="_blank" href="https://economictimes.indiatimes.com/industry/telecom/telecom-news/brookfield-buys-space-teleinfra-for-over-rs-900-crore-in-cash-cum-units-deal/articleshow/84586682.cms">Know More</a>
            </div>
            <div className="newsp_div11">
              <img src="/assets/newsroom/newsPageimg3.jpg" alt="" />
              <span>
                Brookfield-led Tower Infrastructure to acquire Space Teleinfra
                for Rs. 900cr
              </span>
              <a target="_blank" href="https://www.indiainfoline.com/top-share-market-news">Know More</a>
            </div>{" "}
            <div className="newsp_div11">
              <img src="/assets/newsroom/newsPageimg4.jpg" alt="" />
              <span>
                Paving the way towards a connected future with Space Teleinfra
              </span>
              <a target="_blank" href="https://www.businessworld.in/article/Paving-The-Way-Towards-A-Connected-Future-With-Space-Teleinfra/24-06-2022-433984/">Know More</a>
            </div>
          </div>



          <div className="newsp_div1">
            <div className="newsp_div11">
              <img src="/assets/newsroom/newsPageimg5.jpg" alt="" />
              <span>
                Connecting Millions... where they live work and travel.
              </span>
              <Link  onClick={openModal}>Know More</Link>
            </div>
          </div>
        </div>

        <div className="news_flex2">
          <div className="newsp_div2">Media Kit</div>
          <div className="newsp_div3">
            <div className="announcement_div1">
              <div className="announcement_div11">
                <a target="_blank" rel="noopener noreferrer"href="/assets/newsroom/Crest-Logo.pdf">
                  <img src="/assets/newsroom/pdf_icon.svg" alt="" />
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="/assets/newsroom/Crest-Logo.pdf"
                  className=""
                >
                  Crest Digitel Logo
                </a>
              </div>
              <div className="announcement_div11">
                
              <a href="/assets/newsroom/Crest-Boiler-Plate.pdf"
                  target="_blank"
                  rel="noopener noreferrer" ><img src="/assets/newsroom/pdf_icon.svg" alt="" /></a>
                <a
                  href="/assets/newsroom/Crest-Boiler-Plate.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className=""
                >
                  Boiler Plate
                </a>
              </div>
              <div className="announcement_div11">
              <a href="/assets/newsroom/Crest-Brand-Guidelines.pdf"
                  target="_blank"
                  rel="noopener noreferrer"><img src="/assets/newsroom/pdf_icon.svg" alt="" /></a>
                
                <a
                  href="/assets/newsroom/Crest-Brand-Guidelines.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className=""
                >
                  Brand Guidelines
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {modalOpen && <NewsModal closeModal={closeModal} />}
    </div>
  );
};

export default Newsroom;
